import { getSupabaseClient } from '@/integrations/supabase/client';
import { PaymentMethod } from '@/types';

export const paymentMethodsService = {

    async getPaymentMethods(organizationId: string) {
        const supabase = getSupabaseClient();
        const { data, error } = await supabase
            .from('payment_methods')
            .select('*')
            .eq('organization_id', organizationId);

        if (error) {
            throw new Error(`Error fetching payment methods: ${error.message}`);
        }

        return data.map(method => ({
          id: method.id,
          name: method.name,
          icon: method.icon,
          isActive: method.is_active || false,
          createdAt: new Date(method.created_at || ''),
          organizationId: method.organization_id,
          defaultPaymentMethodId: method.default_payment_method_id
        })) as PaymentMethod[];
    },

    async createPaymentMethod(method: Omit<PaymentMethod, 'id' | 'createdAt' | 'organizationId'>, organizationId: string) {
        const supabase = getSupabaseClient();
        const { data, error } = await supabase
            .from('payment_methods')
            .insert([{
                name: method.name,
                icon: method.icon,
                is_active: method.isActive,
                organization_id: organizationId
            }])
            .select()
            .single();

        if (error) {
            throw new Error(`Error creating payment method: ${error.message}`);
        }
        return data;
    },

    async updatePaymentMethod(method: PaymentMethod) {
        const supabase = getSupabaseClient();
        const { data, error } = await supabase
            .from('payment_methods')
            .update({
                name: method.name,
                icon: method.icon,
                is_active: method.isActive
            })
            .eq('id', method.id)
            .select()
            .single();

        if (error) {
            throw new Error(`Error updating payment method: ${error.message}`);
        }
        return data;
    },

    async deletePaymentMethod(methodId: string) {
        const supabase = getSupabaseClient();
        const { data, error } = await supabase
            .from('payment_methods')
            .delete()
            .eq('id', methodId)

        if (error) {
            throw new Error(`Error deleting payment method: ${error.message}`);
        }
        return data;
    }

}